<template>
  <div
    v-if="isLoading"
    class="loader"
  />
  <div
    v-else
    class="clinic_role_form"
  >
    <ul>
      <li
        v-for="(role_i18n, role) in roles"
        :key="role"
      >
        <a
          type="submit"
          class="btn"
          @click.prevent="updateRole(role)"
        >{{ role_i18n }} </a>
      </li>
    </ul>
  </div>
</template>
<script>
  import ClinicApi from '../../../api/clinics.js'
  const ROLES = {
    director: '院長',
    assistant_director: '副院長',
    dental_hygienist_director: '衛生士長',
    staff: 'スタッフ'
  }

  export default {
    props: {
      clinicUser: {
        type: Object,
        requires: true,
        default: null
      },
    },
    data () {
      return {
        clinicName: [],
        isLoading: false,
      }
    },
    computed: {
      roles: () => ROLES,
      clinicUserId: vm => vm.clinicUser && vm.clinicUser.id,
    },
    methods: {
      updateRole(role) {
        this.isLoading = true
          ClinicApi.updateClinicUser(this.clinicUserId, { role: role }).then((res) => {
          this.$emit('updated', res.data.clinicUser)
        }).finally(() => {
        })
      }
    }
  }

</script>
<style scoped>
.btn {
  margin: 0px auto;
}
.clinic_role_form li {
  padding: 20px 0;
  height: auto !important;
}
</style>
